import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Create Supabase client with persistent session handling
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})

// Function to get the current session
export async function getCurrentSession() {
  const { data } = await supabase.auth.getSession();
  return data.session;
}

// Function to refresh the session if needed
export async function refreshSession() {
  const { data, error } = await supabase.auth.refreshSession();
  if (error) {
    console.error('Error refreshing session:', error);
    return { success: false, error };
  }
  return { success: true, session: data.session };
}

// Function to refresh the schema cache - completely rewritten to avoid the 404 error
export async function refreshSchemaCache() {
  console.log('Attempting to refresh schema cache (root supabase.ts)...')
  try {
    // Simply execute a basic query to ensure schema is fresh
    // Use a table we know exists - contracts
    const { data, error } = await supabase
      .from('contracts')
      .select('id')
      .limit(1)
    
    if (error) {
      console.error('Error refreshing schema cache:', error)
      return { success: false, error }
    }
    
    console.log('Schema cache refresh successful (without RPC call)')
    return { success: true, data }
  } catch (err) {
    console.error('Exception refreshing schema cache:', err)
    return { success: false, error: err }
  }
}
